import styled from 'styled-components';
import { useThemeMode } from '../providers/ThemeModeProvider';

// Toggle claro/oscuro. $floating = pill fija arriba a la derecha (auth, sin
// sidebar); sin la prop = botón inline para el sidebar.

const Btn = styled.button<{ $floating?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: ${({ $floating }) => ($floating ? 'auto' : '100%')};
  padding: ${({ $floating }) => ($floating ? '8px 14px' : '8px 12px')};
  border-radius: ${({ theme, $floating }) => ($floating ? theme.borderRadius.full : theme.borderRadius.md)};
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

  ${({ $floating, theme }) => $floating && `
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 50;
    box-shadow: ${theme.shadows.md};
  `}

  &:hover {
    color: ${({ theme }) => theme.colors.text};
    border-color: ${({ theme }) => theme.colors.borderHover};
    background: ${({ theme }) => theme.colors.surfaceHover};
  }
`;

const Glyph = styled.span`
  font-size: 15px;
  line-height: 1;
`;

export function ThemeToggle({ floating = false, showLabel = true }: { floating?: boolean; showLabel?: boolean }) {
  const { mode, toggle } = useThemeMode();
  const isDark = mode === 'dark';
  return (
    <Btn
      type="button"
      $floating={floating}
      onClick={toggle}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <Glyph>{isDark ? '☀️' : '🌙'}</Glyph>
      {showLabel && <span>{isDark ? 'Light' : 'Dark'}</span>}
    </Btn>
  );
}
